import { render, staticRenderFns } from "./Memo.pug?vue&type=template&id=242c2f93&scoped=true&lang=pug&"
import script from "./Memo.vue?vue&type=script&lang=js&"
export * from "./Memo.vue?vue&type=script&lang=js&"
import style0 from "./Memo.scss?vue&type=style&index=0&id=242c2f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c2f93",
  null
  
)

export default component.exports